import { useEffect, useRef } from 'react';
import { reminderApi } from '../api';
import { parseUTC } from '../utils/dateUtils';

const SHOWN_REMINDER_KEY = 'tracern:shownReminderIds';
const POLL_MS = 5000;

function loadShownReminderIds() {
  try {
    return new Set(JSON.parse(sessionStorage.getItem(SHOWN_REMINDER_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

function saveShownReminderIds(set) {
  const arr = [...set].slice(-200);
  sessionStorage.setItem(SHOWN_REMINDER_KEY, JSON.stringify(arr));
}

/** Active reminder whose due time has passed (same rule as Reminders page overdue). */
export function isReminderDue(reminder) {
  if (!reminder || reminder.dismissed) return false;
  const due = parseUTC(reminder.remindAt);
  return due && !isNaN(due.getTime()) && due.getTime() <= Date.now();
}

/**
 * Polls GET /reminders and fires onDueReminder when remindAt passes.
 * This matches what the user sees on /reminders — server notification polling alone
 * can miss alerts if the scheduler tick or 15s poll is late.
 */
export function useReminderAlerts(onDueReminder) {
  const shownRef = useRef(loadShownReminderIds());
  const onDueRef = useRef(onDueReminder);
  onDueRef.current = onDueReminder;

  useEffect(() => {
    const check = () => {
      reminderApi.getActive()
        .then(res => {
          const reminders = res.data?.data || [];
          reminders.filter(isReminderDue).forEach(r => {
            const key = String(r.id);
            if (shownRef.current.has(key)) return;
            shownRef.current.add(key);
            saveShownReminderIds(shownRef.current);
            onDueRef.current?.(r);
          });
        })
        .catch(() => {});
    };

    check();
    const id = setInterval(check, POLL_MS);
    return () => clearInterval(id);
  }, []);
}
